import { Component, OnInit } from '@angular/core';
import {LoadingController, NavController} from '@ionic/angular';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastService} from '../../../services/toast.service';
import {ApiService} from '../../../services/api.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-order-finish',
  templateUrl: './order-finish.page.html',
  styleUrls: ['./order-finish.page.scss'],
})
export class OrderFinishPage implements OnInit {

  currentUser: any;
  orderForm: FormGroup;
  cart: any;
  existingDeclination: any;
  currentDistributorId: any = null;
  currentDistributor: any = null;

  constructor(private navController: NavController,
              private toastService: ToastService,
              private loadingController: LoadingController,
              private apiService: ApiService,
              public route: ActivatedRoute) {
    this.currentUser = this.apiService.authApi.currentUser;
    this.currentDistributorId = this.route.snapshot.paramMap.get('distributorId');
  }

  ngOnInit() {
    this.loadCart();
    this.orderForm = new FormGroup({
      iban: new FormControl('', Validators.compose([Validators.required])),
      bic: new FormControl('', Validators.compose([Validators.required])),
    });

    if (this.currentDistributorId){
      this.apiService.userApi.get(this.currentDistributorId).then((data) => {
        this.currentDistributor = data;
        this.orderForm.controls.iban.setValue(this.currentDistributor.infos?.iban);
        this.orderForm.controls.bic.setValue(this.currentDistributor.infos?.bic);
      });
    } else if (this.currentUser){
      this.orderForm.controls.iban.setValue(this.currentUser.infos?.iban);
      this.orderForm.controls.bic.setValue(this.currentUser.infos?.bic);
    }
  }

  async doAction() {
    if (this.orderForm.invalid) { return; }

    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    this.apiService.userApi.command({
      iban : this.orderForm.controls.iban.value,
      bic : this.orderForm.controls.bic.value,
    }, this.currentDistributorId).then((e: any) => {
      loading.dismiss();
      this.toastService.success('Commande passée avec succès');

      if (!this.currentDistributorId){
        this.apiService.authApi.currentUser = e;
      }

      this.navController.navigateRoot('/home');
    }).catch(() => {
      this.toastService.error('Erreur lors de votre commande');
      loading.dismiss();
    });
  }

  replaceTo(uri){
    if (this.currentDistributorId){
      this.navController.navigateRoot(uri + '/' + this.currentDistributorId);
    } else {
      this.navController.navigateRoot(uri);
    }
  }

  async loadCart() {
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();
    this.apiService.cartApi.get(this.currentDistributorId).then((c) => {
      this.cart = c;
      this.apiService.cartApi.getDeclination().then((d) => {
        this.existingDeclination = d;
        loading.dismiss();
      });
    }).catch(() => {
      loading.dismiss();
    });
  }

  total(index){
    let total = 0;
    let count = 0;
    if (this.cart.cart_products[index].pro_product.maxQuantity === null
        && this.cart.cart_products[index].pro_product.minQuantity === null){
      for (const declination of this.existingDeclination){
        total += this.cart.cart_products[index].price * JSON.parse(this.cart.cart_products[index].colors)['quantity-' + declination.id];
        count += JSON.parse(this.cart.cart_products[index].colors)['quantity-' + declination.id];
      }
    } else if (this.cart.cart_products[index].pro_product.maxQuantity !== null
        || this.cart.cart_products[index].pro_product.minQuantity !== null){
      for (const declination of this.existingDeclination){
        total += this.cart.cart_products[index].price * JSON.parse(this.cart.cart_products[index].colors)['quantity-' + declination.id];
        count += JSON.parse(this.cart.cart_products[index].colors)['quantity-' + declination.id];
      }
      if (this.cart.cart_products[index].free){
        let soustraire = 0;
        if (Math.floor(count / 120) > 0){
          soustraire = Math.floor(count / 120) * 20 * this.cart.cart_products[index].price;
          total -= soustraire;
        }
      }
    }
    return total.toFixed(2);
  }

  getQuantity(index, id){
    // tslint:disable-next-line:radix
    return parseInt(JSON.parse(this.cart.cart_products[index].colors)['quantity-' + id]);
  }

  getAllQuantity(index){
    let total = 0;
    for (const declination of this.existingDeclination){
      // tslint:disable-next-line:radix
      total += parseInt(JSON.parse(this.cart.cart_products[index].colors)['quantity-' + declination.id]);
    }
    return total;
  }

}
